import MobileMenu from "layout/Menu/MobileMenu";
import { useAccount } from "context/AccountContext";
import { useDialog } from "context/DialogContext";
import Logo from "layout/Header/Logo/Logo";
import "layout/Header/Header/Header.scss";
import NotificationBar from "components/ui/NotificationBar/NotificationBar";
import Alert from "components/ui/Alert/Alert";
import ProfileCreateUpdate from "pages/Profile/ProfileCreateUpdate";
import TopMenuList from "layout/Menu/TopMenuList";
import MainMenuList from "layout/Menu/MainMenuList";
import UserMenu from "layout/UserMenu/UserMenu";
import Button from "components/ui/Button/Button";
import LoginDialog from "features/authentication/components/LoginDialog";

function Header() {
  const { showDialog } = useDialog();
  const { profile } = useAccount();
  const { user } = useAccount();

  const openProfileDialog = (event) => {
    event.preventDefault();
    showDialog(<ProfileCreateUpdate/>);
  }

  let notificationTitle;
  let notificationMessage;
  if (profile?.field_profile_completed?.value === "0") {
    notificationTitle = 'Profiel aanmaken';
    notificationMessage = <span>U bent nog niet zichtbaar voor andere leden. <a onClick={ openProfileDialog } href={ '/' }>Maak nu uw profiel compleet.</a>
    </span>;
  } else if (profile?.field_profile_hide_profile?.value === "1") {
    notificationTitle = 'Profiel zichtbaar maken';
    notificationMessage =
      <span>Je bent niet zichtbaar voor andere leden omdat je dit in je profiel hebt aangegeven, &nbsp;
        <a onClick={ openProfileDialog } href={ '/' }>maak hier je profiel zichtbaar</a>
    </span>;
  }

  let button;
  if (user) {
    button = <UserMenu/>;
  } else {
    button = <Button onClick={ () => showDialog(<LoginDialog/>) }
                     variant="secondary">Inloggen</Button>;
  }
  return (
    <>
      <div className="header-spacer"></div>
      <div className="header-container">
        <div className="wrapper--fluid">
          <header className="header">
            <div className={ `header__top` }>
              <div className="header__mobile-menu">
                <MobileMenu/>
              </div>

              <div className="header__logo">
                <Logo/>
              </div>

              <ul className="header__menu header__menu--top">
                <TopMenuList/>
              </ul>
              { button }
            </div>

            <div className={ `header__bottom `}>
              <ul className="header__menu header__menu--main">
                <MainMenuList/>
              </ul>
            </div>
          </header>
        </div>
      </div>
      {
        notificationMessage &&
        <NotificationBar>
          <Alert title={ notificationTitle } type={ 'warning' } message={ notificationMessage }/>
        </NotificationBar>
      }
    </>
  )
}

export default Header;
